import { useRouter } from 'vue-router';

import { isDirectoryPermanentRedirectError } from '@/helpers/Directory/directoryCanonicalRedirect';
import { isDirectoryPageNotFoundError } from '@/helpers/Directory/directoryLocationValidation';

/**
 * Client-side handling for new-SRP route validation failures:
 * - PAGE_NOT_FOUND → in-app not-found route
 * - PERMANENT_REDIRECT → navigate to the canonical path
 */
export const useDirectoryRouteNotFoundRedirect = () => {
  const router = useRouter();

  return async (error: unknown): Promise<void> => {
    if (isDirectoryPageNotFoundError(error)) {
      await router.replace({ name: 'pageNotFound' });
      return;
    }

    if (isDirectoryPermanentRedirectError(error)) {
      const redirectUri = (error as Error & { redirectUri: string }).redirectUri;
      await router.replace(redirectUri);
      return;
    }

    throw error;
  };
};
